/**
 * Mock data for Orders MFE
 * TODO: Replace with API calls to fetch real customers/suppliers/products
 */

import type { MockCustomer, MockSupplier } from "../interfaces/mockData";

// Sample customers - TODO: Replace with API call
export const SampleCustomers: MockCustomer[] = [
  { id: "CUST-001", name: "John Doe", email: "john.doe@example.com" },
  { id: "CUST-002", name: "Jane Smith", email: "jane.smith@example.com" },
  {
    id: "CUST-003",
    name: "Tech Solutions Inc.",
    email: "contact@techsolutions.com"
  }
];

// Sample suppliers - TODO: Replace with API call
export const SampleSuppliers: MockSupplier[] = [
  {
    id: "SUP-001",
    name: "ABC Suppliers Inc.",
    email: "contact@abcsuppliers.com",
    status: "ACTIVE"
  },
  {
    id: "SUP-002",
    name: "XYZ Trading Co.",
    email: "info@xyztrading.com",
    status: "ACTIVE"
  },
  {
    id: "SUP-003",
    name: "Global Supplies Ltd.",
    email: "sales@globalsupplies.com",
    status: "ACTIVE"
  }
];
